import { Link } from 'react-router-dom';
import { t } from '../i18n';

export default function SettingsPage() {
  return (
    <>
      <h2 className="text-2xl font-semibold mb-4 text-blue-600">{t('Подесувања')}</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Link
          to="/settings/mybussiness"
          className="block p-4 bg-white rounded-lg shadow hover:shadow-md hover:bg-blue-50 transition"
        >
          <h3 className="text-lg font-semibold text-blue-600 mb-2">{t('Податоци за бизнисот')}</h3>
          <p className="text-gray-500">{t('Внесете ги податоците.')}</p>
        </Link>
      </div>
    </>
  );
}
